import { sectionRenderer } from '@theme/section-renderer';

class ProductLeadData {
  constructor() {
    this.variants = document.querySelectorAll('.section-variants .variant-values');
    this.apiUrl = document.querySelector('[data-api]')?.dataset.api;
    this.preloader = document.querySelector('.preloader-ring');
    this.errorField = document.querySelector('.error-message');
    this.carSelectorElement = document.querySelector('.car-selectors');
    this.dynamicButtonText = document.querySelector('.redirect-dynamic-text')?.textContent;
    this.redirectButton = document.querySelector('.redirect-btn');
    this.dynamicProductsElement = document.querySelector('.eva-synced-products')?.textContent;
    this.dynamicProductsData = this.dynamicProductsElement ? JSON.parse(this.dynamicProductsElement) : [];
    this.dynamicProducts = window.Shopify?.dynamicProductRedirects || {};
    this.carSelectors = {
      make: this.carBrand,
      model: this.carModel,
      generation: this.carGeneration,
      transmission: this.carTransmisson,
      body_type: this.carBody,
    };
    this.needToRedirect = { redirect: false, redirect_url: '', car_type: '' };
    this.searchParamsLoaded = false;
    this.carSelectorsUpdating = true;
    this.customCarParameters = { make: 0, model: 0, generation: 0, transmission: 0, body_type: 0 };
  }

  handleSelectorLoading() {
    this.carSelectorsUpdating = false;
  }

  clearSelectors(type) {
    let isNeedToUpdate = false;
    if (!type) {
      isNeedToUpdate = true;
    }
    document.querySelectorAll('.nice-select').forEach((niceSelect) => {
      if (niceSelect.previousElementSibling.id == `voo-car-${type}`) {
        isNeedToUpdate = true;
      } else if (isNeedToUpdate) {
        this.carSelectors[niceSelect.previousElementSibling.id.split('voo-car-')[1]].update();
      }
    });
  }

  validateCarParams(obj) {
    const keysToValidate = ['make', 'model', 'generation', 'body_type', 'transmission'];
    for (let [key, value] of Object.entries(obj)) {
      if (keysToValidate.some((element) => element === key) && !Number.isInteger(+value)) return false;
    }
    return true;
  }

  async updateSelectors(selector, type, id = false) {
    let carParameters = {
      locale: document.querySelector('html').getAttribute('lang'),
    };
    // if car have previous params set to carParameters object
    if (id) {
      ['make', 'model', 'generation', 'body_type', 'transmission'].forEach((el) => {
        if (document.querySelector(`.voo-back-data select[data-type="${el}"]`).dataset.value) {
          carParameters[`${el}`] = document.querySelector(`.voo-back-data select[data-type="${el}"]`).dataset.value;
        }
      });
    }

    // Get placeholder for nice select
    let placeholder = selector.dataset
      ? selector.dataset.placeholder
      : document.getElementById(`${selector}`).dataset.placeholder;

    // Options for nice select
    let niceSelectOptions = {
      placeholder: placeholder,
      searchPlaceholder: 'Search',
      searchable: true,
    };

    // if has car pametrs in url
    this.searchParams = new URLSearchParams(window.location.search);
    if (!this.searchParams.get('transmission')) {
      this.preloader instanceof HTMLElement ? (this.preloader.style.display = 'none') : null;
      this.carSelectorElement.style.display = 'flex';
      this.handleSelectorLoading();
    }

    if (type) {
      // Get car parameters
      let validated = this.validateCarParams(carParameters);

      (validated
        ? this.getCarData(this.apiUrl + type, carParameters).then((res) => res.json())
        : Promise.resolve({ data: [], status: true, extra_data: [] })
      )
        .then((data) => {
          if (type == 'make') {
            // Update nice select and add groups
            let optionGroupPopular = document.createElement('optgroup');
            optionGroupPopular.class = 'popular-car';
            optionGroupPopular.label = 'Popular Cars';
            let optionGroupOther = document.createElement('optgroup');
            optionGroupOther.class = 'other-car';
            optionGroupOther.label = 'Other Cars';
            selector.appendChild(optionGroupPopular);
            selector.appendChild(optionGroupOther);

            // Load data to select and group to popular and other
            data.data.forEach((option) => {
              let optionElement = document.createElement('option');
              optionElement.value = option.id;
              optionElement.innerText = option.name;

              if (option.is_popular == 1) {
                optionElement.classList.add('popular');
                optionGroupPopular.appendChild(optionElement);
              } else {
                optionGroupOther.appendChild(optionElement);
              }
            });

            // After adding data update nice select
            this.carSelectors[type].update();
            selector.nextElementSibling.classList.remove('error-data');

            // Clear another selectors if data were loaded
            this.clearSelectors(type);

            // Add data attribute to selector
            if (id)
              document.querySelector(`.voo-back-data select[data-type="${type}"]`).setAttribute('data-value', `${id}`);

            // If have url params and this params not loaded -> click to next select to load next param
            if (this.searchParams.get(type) && !this.searchParamsLoaded) {
              setTimeout(() => {
                if (
                  document.querySelector(
                    `#voo-car-${type} + .nice-select li[data-value="${this.searchParams.get(type)}"]`,
                  )
                ) {
                  document
                    .querySelector(`#voo-car-${type} + .nice-select li[data-value="${this.searchParams.get(type)}"]`)
                    .click();
                } else {
                  selector.nextElementSibling.querySelector('input.nice-select-search').value =
                    this.searchParams.get(type);

                  let newOption = document.createElement('option');
                  newOption.textContent = this.searchParams.get(type);
                  newOption.classList.add('custom');
                  selector.querySelector('option.hidden').after(newOption);
                  // Update selector and clear others
                  this.carSelectors[type].update();
                  this.clearSelectors(type);

                  // Update custom paramets
                  this.customCarParameters[type] = 1;

                  // Select new param
                  selector.nextElementSibling.classList.remove('error-data');
                  selector.nextElementSibling
                    .querySelector(`.option[data-value="${this.searchParams.get(type)}"]`)
                    .click();
                }
                // by default after click nice select is opening so i close it
                selector.nextElementSibling.classList.remove('open');
              }, 50);
            }
          } else {
            // Clean from last data if had except of default param
            selector.querySelectorAll('option').forEach((el) => {
              if (!el.classList.contains('hidden')) el.remove();
            });

            if (data.data.length === 0) {
              this.redirectButton.removeAttribute('disabled');

              let titleParams = '';
              ['make', 'model', 'generation', 'body_type', 'transmission'].forEach((type, i) => {
                const selectedTypeParam = document.getElementById(`voo-car-${type}`).dataset.value;
                if (selectedTypeParam) {
                  this.searchParams.set(type, selectedTypeParam);
                } else {
                  this.searchParams.delete(type);
                }
              });
              window.history.replaceState(
                {},
                '',
                window.location.origin + window.location.pathname + `?${this.searchParams.toString()}`,
              );
              this.searchParamsLoaded = true;
              this.getAndUpdateAditionalData(this.searchParams.toString());
            }
            // Load data to select
            data.data.forEach((option) => {
              let updatedName = option.name;

              if (type == 'generation' && option.name.includes('generation')) {
                updatedName = formatGeneration(updatedName).replace(/\((\d{4}) - present\)/gi, '(from $1)');
              }

              if (type == 'body_type') {
                updatedName = updatedName.replace(/(\d+)-doors/g, '$1 doors');
              }

              let optionElement = document.createElement('option');
              optionElement.value = option.id;
              optionElement.innerText = updatedName;
              selector.appendChild(optionElement);
            });

            // if transmission check if product the same type
            // If not set redirect url and last step will be redirect to new type with car params
            if (type == 'body_type') {
              if (data.data[0].car_category_key) {
                this.needToRedirect.redirect = true;
                let matched = false;
                for (const key in this.dynamicProducts) {
                  if (`${key}` === data.data[0].car_category_key) {
                    this.needToRedirect.redirect_url = this.dynamicProducts[key];
                    this.needToRedirect.car_type = key;
                    matched = true;
                    break;
                  }
                }

                if (!matched) {
                  this.needToRedirect.redirect_url = this.dynamicProducts.standard;
                  this.needToRedirect.car_type = 'regular';
                  if (document.querySelector('[data-template]').dataset.template === 'regular') {
                    this.needToRedirect.redirect = false;
                  }
                }
              } else {
                this.needToRedirect.redirect = false;
              }
            }

            // After adding data update nice select
            this.carSelectors[type].update();

            // Clear another selectors if data were loaded
            this.clearSelectors(type);

            // If have url params -> click to next select to load next param
            if (this.searchParams.get(type) && !this.searchParamsLoaded) {
              setTimeout(() => {
                // Check if search param correct
                if (
                  document.querySelector(
                    `#voo-car-${type} + .nice-select li[data-value="${this.searchParams.get(type)}"]`,
                  )
                ) {
                  document
                    .querySelector(`#voo-car-${type} + .nice-select li[data-value="${this.searchParams.get(type)}"]`)
                    .click();
                } else {
                  selector.nextElementSibling.querySelector('input.nice-select-search').value =
                    this.searchParams.get(type);

                  let newOption = document.createElement('option');
                  newOption.textContent = this.searchParams.get(type);
                  newOption.classList.add('custom');
                  selector.querySelector('option.hidden').after(newOption);
                  // Update selector and clear others
                  this.carSelectors[type].update();
                  this.clearSelectors(type);

                  // Update custom paramets
                  this.customCarParameters[type] = 1;

                  // Select new param
                  selector.nextElementSibling.classList.remove('error-data');
                  selector.nextElementSibling
                    .querySelector(`.option[data-value="${this.searchParams.get(type)}"]`)
                    .click();
                }

                // by default after click nice select is opening so i close it
                selector.nextElementSibling.classList.remove('open');
              }, 50);
            }

            // Remove selected from updated select
            selector.nextElementSibling.querySelector('li.option:not(.disabled)')?.classList.remove('selected');
            selector.nextElementSibling.classList.remove('error-data');
          }
        })
        .catch((error) => {
          console.error('Error loading', error);
          this.errorField.style.display = 'block';
          this.preloader.style.display = 'none';
        });
    } else {
      const select = document.getElementById(`${selector}`);
      select.classList.add('error-data');
      // Initialize epmty nice selectors
      for (const key in this.carSelectors) {
        if (selector == `voo-car-${key}`) {
          if (key == 'make') {
            niceSelectOptions.searchPlaceholder = 'Search';
          } else {
            niceSelectOptions.searchPlaceholder = 'Search or add yourself';
          }
          this.carSelectors[key] = NiceSelect.bind(select, niceSelectOptions);
        }
      }
    }
  }

  getCarData(url, params) {
    let timeout = setTimeout(() => {
      this.carSelectorElement.classList.add('updating');
      this.preloader.style.display = 'flex';
    }, 500);

    let data = fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Shopify-Shop-Domain': document.querySelector('[data-domain]').getAttribute('data-domain'),
      },
      body: JSON.stringify(params),
    }).finally(() => {
      clearTimeout(timeout);
      this.carSelectorElement.classList.remove('updating');
      this.preloader.style.display = 'none';
    });

    return data;
  }

  redirectToProductPage() {
    let newUrl =
      window.location.origin + '/products/' + this.needToRedirect.redirect_url + '?' + this.searchParams.toString();
    return newUrl;
  }

  getCarPricesCompact(carType) {
    const typeMapping = {
      standard: 'Regular',
      micro: 'Micro',
      van: 'Van',
      electro: 'EV',
    };

    const productType = typeMapping[carType.toLowerCase()];
    const carProducts = this.dynamicProductsData.filter((p) => p.productType === productType);

    return {
      frontPrice: carProducts.find((p) => p.productSet === 'Front set')?.productPrice || null,
      fullPrice: carProducts.find((p) => p.productSet === 'Full set')?.productPrice || null,
    };
  }

  formatButtonText() {
    if (this.dynamicButtonText && this.needToRedirect.car_type != '') {
      const { frontPrice, fullPrice } = this.getCarPricesCompact(this.needToRedirect.car_type);
      let formattedText = this.dynamicButtonText
        .replace('[front_price]', frontPrice || 'N/A')
        .replace('[full_price]', fullPrice || frontPrice || 'N/A');
      this.redirectButton.innerHTML = formattedText;
    }
  }

  async init() {
    // Update type of car
    // Check by pathname what type of car
    for (const key in this.dynamicProducts) {
      if (window.location.pathname.split('products/')[1] == this.dynamicProducts[key]) {
        document.querySelector('[data-domain]').setAttribute('data-type', `${key}`);
      }
    }

    // Init car selectors
    await this.updateSelectors('voo-car-make');
    await this.updateSelectors('voo-car-model');
    await this.updateSelectors('voo-car-generation');
    await this.updateSelectors('voo-car-body_type');
    await this.updateSelectors('voo-car-transmission');
    await this.updateSelectors(
      document.getElementById('voo-car-make'),
      document.getElementById('voo-car-make').dataset.type,
    );

    // Show car selectors and hide preloader
    if (!this.searchParams.get('make')) {
      this.carSelectorElement.style.display = 'flex';
      this.preloader.style.display = 'none';

      this.handleSelectorLoading();
    }

    // Event to open car selectors
    if (document.querySelector('.voo-product-change')) {
      document.querySelector('.voo-product-change').addEventListener('click', () => {
        this.clearSelectors();
        document.querySelector('#voo-car-make + .nice-select').classList.remove('error-data');
        document.querySelectorAll('.nice-select li.selected').forEach((el) => el.classList.remove('selected'));
        this.redirectButton.setAttribute('disabled', 'true');
      });
    }

    // Event when focusout from custom select
    this.carSelectorElement.addEventListener('focusout', (e) => {
      if (e.target.classList.contains('nice-select-search') && e.target.value == '') {
        let defaultSelectId = e.target.closest('.nice-select').previousElementSibling.id;
        const type = e.target.closest('.nice-select').previousElementSibling.dataset.type;
        this.carSelectors[type].update();
        document.getElementById(defaultSelectId).nextElementSibling.classList.remove('error-data');
        document
          .getElementById(defaultSelectId)
          .nextElementSibling.querySelector('li.option.selected:not(.disabled)')
          ?.classList.remove('selected');
        this.clearSelectors(type);
      }
    });

    document.querySelector('.voo-back-data').addEventListener('keydown', (e) => {
      function addToList(target) {
        let inputField = target.value;
        const selectDefault = target.closest('.nice-select').previousElementSibling;
        const type = selectDefault.id.split('voo-car-')[1];
        let newOption = document.createElement('option');
        newOption.innerText = inputField;
        newOption.classList.add('custom');
        selectDefault.querySelector('option.hidden').after(newOption);
        // Update selector and clear others
        this.carSelectors[type].update();
        this.clearSelectors(type);

        // Update custom paramets
        this.customCarParameters[type] = 1;

        // Select new param
        selectDefault.nextElementSibling.classList.remove('error-data');
        selectDefault.nextElementSibling.querySelector(`.option[data-value="${inputField}"]`).click();
      }

      if (
        e.key == 'Enter' &&
        e.target.closest('.nice-select').querySelector('ul.list:not(.empty)') &&
        e.target.closest('.nice-select:not(.error-data)')?.querySelector('ul li.option:not(.disabled)')
      ) {
        if (
          e.target.closest('.nice-select').querySelectorAll('ul.list .option:not(.hidden):not(.disabled)').length > 0
        ) {
          e.target.closest('.nice-select').querySelectorAll('ul.list .option:not(.hidden):not(.disabled)')[0].click();
        } else {
          let updateSelect = addToList.bind(this);
          updateSelect(e.target);
        }
      }
    });

    // Event for car data selectors click
    document.querySelector('.voo-back-data').addEventListener('click', (e) => {
      const nextStepSelect = e.target.closest('.nice-select')?.nextElementSibling;

      if (e.target.classList.contains('search-submit')) {
        // If click to add car param that not exsist
        const select = e.target.closest('.nice-select');
        const selectDefault = select?.previousElementSibling;
        let inputField = select.querySelector('.nice-select-search').value;
        const type = selectDefault.id.split('voo-car-')[1];

        // Update selector and clear others
        this.carSelectors[type].update();
        this.clearSelectors(type);

        // Update custom paramets
        this.customCarParameters[type] = 1;

        // Select new param
        selectDefault.nextElementSibling.classList.remove('error-data');
        selectDefault.nextElementSibling.querySelector(`.option[data-value="${inputField}"]`).click();

        if (type == 'transmission') {
          // Update search parameters and set title
          ['make', 'model', 'generation', 'body_type', 'transmission'].forEach((type, i) => {
            const selectedTypeParam = document.getElementById(`voo-car-${type}`).dataset.value;
            if (selectedTypeParam) {
              this.searchParams.set(type, selectedTypeParam);
            }
          });

          // Enable add to cart button
          this.redirectButton.removeAttribute('disabled');

          // Update url
          window.history.replaceState(
            {},
            '',
            window.location.origin + window.location.pathname + `?${this.searchParams.toString()}`,
          );
        } else {
          // Disable add to cart button
          this.redirectButton.setAttribute('disabled', 'true');
        }
      } else if (e.target.classList.contains('option') && e.target.dataset.value) {
        // Set dataset value
        if (e.target.closest('.nice-select').previousElementSibling) {
          e.target
            .closest('.nice-select')
            .previousElementSibling.setAttribute('data-value', `${e.target.dataset.value}`);
        }

        // Clear all old data value
        let clearValues = false;
        ['make', 'model', 'generation', 'body_type', 'transmission'].forEach((type, i) => {
          if (
            e.target.closest('.nice-select').previousElementSibling &&
            e.target.closest('.nice-select').previousElementSibling.dataset.type == type
          ) {
            clearValues = true;
          } else if (clearValues) {
            document.querySelector(`#voo-car-${type}`).removeAttribute('data-value');
          }
        });

        // Remove custom select elements
        for (const key in this.customCarParameters) {
          if (
            e.target.closest('.nice-select').previousElementSibling &&
            key == e.target.closest('.nice-select').previousElementSibling.dataset.type &&
            Number(e.target.dataset.value) &&
            !e.target.classList.contains('voo_custom')
          ) {
            this.customCarParameters[key] = 0;
          }
        }

        e.target.closest('.nice-select ul').childNodes.forEach((element) => {
          element.classList.remove('hidden');
        });

        if (nextStepSelect) {
          // If have next select (not last option)
          this.updateSelectors(nextStepSelect, nextStepSelect.dataset.type, e.target.dataset.value);

          // Disable add to cart button
          this.redirectButton.setAttribute('disabled', 'true');
        } else {
          // If dont have last select (last option);
          // Hide preloader
          this.preloader.style.display = 'none';
          this.carSelectorElement.style.display = 'flex';

          this.handleSelectorLoading();

          let titleParams = '';
          // Update search parameters and set title
          ['make', 'model', 'generation', 'body_type', 'transmission'].forEach((type, i) => {
            this.searchParams.set(type, document.getElementById(`voo-car-${type}`).dataset.value);
            const optionTitle = document.querySelector(
              `#voo-car-${type} + .nice-select li.selected:not(.disabled)`,
            ).innerHTML;
            titleParams += i === 4 ? optionTitle : optionTitle + ' ';
          });

          // If data was loaded from url, prevent new reload
          this.searchParamsLoaded = true;

          // Enable add to cart button
          this.redirectButton.removeAttribute('disabled');
          this.redirectButton.href = this.redirectToProductPage();
          this.formatButtonText();

          // Update url
          window.history.replaceState(
            {},
            '',
            window.location.origin + window.location.pathname + `?${this.searchParams.toString()}`,
          );
        }
      }
    });

    // Event add to Cart
    this.redirectButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (!e.target.hasAttribute('disabled')) {
        window.location.href = this.redirectToProductPage();
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Init script
  let ProductLeadInstance = new ProductLeadData();
  ProductLeadInstance.init();
});
